/**
 * Monto — una cifra que se oculta cuando el usuario eligió no mostrar montos.
 *
 * Recibe el texto **ya formateado** como hijo: el formato (moneda, decimales,
 * separadores del país) es de quien llama y no se reimplementa acá.
 *
 * 🔴 La máscara es **siempre la misma** (`$ ••••••`), no una por dígito. Una que
 * respetara la cantidad de cifras —«$ •.•••.•••»— diría que el sueldo tiene siete
 * dígitos, que es justamente lo que se quiere tapar.
 *
 * Mientras está oculto, el lector de pantalla oye «Monto oculto» y no la cifra.
 */
import type { ReactNode } from 'react'
import { useMontosStore } from '@/store/montosStore'

export const MASCARA_MONTO = '$ ••••••'

export interface MontoProps {
  /** El monto ya formateado por quien llama. */
  children?: ReactNode
  /** `false` para una cifra que no es personal (un total público): nunca se oculta. */
  sensible?: boolean
  className?: string
}

export function Monto({ children, sensible = true, className = '' }: MontoProps) {
  const visibles = useMontosStore(s => s.visibles)
  if (!sensible || visibles) return <span className={className}>{children}</span>
  return (
    <span className={`select-none ${className}`.trim()} aria-label="Monto oculto" title="Monto oculto">
      <span aria-hidden="true">{MASCARA_MONTO}</span>
    </span>
  )
}
